<div class="card-body">
    <div class="search-component d-flex flex-wrap">
        <div class="col-sm-12 d-flex justify-content-between flex-wrap">
            <div class="col-sm-11 d-flex gap-3 flex-column">
                <div class="col-sm-12 d-flex gap-5 flex-wrap">
                </div>
            </div>
        </div>
    </div>
</div>
